import { useEffect, useState } from 'react';
import { notifApi } from '../../api/notifications.js';

const TYPES = [
  { id: 'workflow.assigned', label: 'A step is assigned to you' },
  { id: 'workflow.approved', label: 'Your request is approved' },
  { id: 'workflow.rejected', label: 'Your request is rejected' },
  { id: 'workflow.escalated', label: 'A step is escalated (overdue)' },
  { id: 'workflow.completed', label: 'A workflow you initiated completes' },
];

export default function NotificationPreferences() {
  const [prefs, setPrefs] = useState(null);
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => { notifApi.preferences().then((d) => setPrefs(d?.preferences || defaults())); }, []);

  function defaults() { return { email_enabled: true, inapp_enabled: true, type_overrides: {} }; }
  function setOverride(type, channel, value) {
    setPrefs((p) => ({
      ...p,
      type_overrides: { ...(p.type_overrides || {}), [type]: { ...(p.type_overrides?.[type] || {}), [channel]: value } },
    }));
  }

  async function save() {
    setError(null); setInfo(null);
    try {
      await notifApi.updatePreferences({
        emailEnabled: prefs.email_enabled,
        inappEnabled: prefs.inapp_enabled,
        typeOverrides: prefs.type_overrides,
      });
      setInfo('Saved');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed');
    }
  }

  if (!prefs) return <div className="muted">Loading…</div>;

  return (
    <section>
      <header className="page-header">
        <h1>Notification Preferences</h1>
        <button className="btn primary" onClick={save}>Save</button>
      </header>

      {error && <div className="alert error">{error}</div>}
      {info && <div className="alert info">{info}</div>}

      <div className="card form-card">
        <h3>Defaults</h3>
        <label className="checkbox-row">
          <input type="checkbox" checked={prefs.inapp_enabled} onChange={(e) => setPrefs({ ...prefs, inapp_enabled: e.target.checked })} />
          In-app notifications
        </label>
        <label className="checkbox-row">
          <input type="checkbox" checked={prefs.email_enabled} onChange={(e) => setPrefs({ ...prefs, email_enabled: e.target.checked })} />
          Email notifications
        </label>
      </div>

      <div className="card">
        <h3>Per-event overrides</h3>
        <p className="muted small">Leave a checkbox unchanged to use the default above.</p>
        <table className="data-table">
          <thead><tr><th>Event</th><th>In-app</th><th>Email</th></tr></thead>
          <tbody>
            {TYPES.map((t) => {
              const o = prefs.type_overrides?.[t.id] || {};
              return (
                <tr key={t.id}>
                  <td><strong>{t.label}</strong><br /><code className="muted small">{t.id}</code></td>
                  <td>
                    <select value={o.inapp === undefined ? '' : String(o.inapp)} onChange={(e) => setOverride(t.id, 'inapp', e.target.value === '' ? undefined : e.target.value === 'true')}>
                      <option value="">default</option>
                      <option value="true">on</option>
                      <option value="false">off</option>
                    </select>
                  </td>
                  <td>
                    <select value={o.email === undefined ? '' : String(o.email)} onChange={(e) => setOverride(t.id, 'email', e.target.value === '' ? undefined : e.target.value === 'true')}>
                      <option value="">default</option>
                      <option value="true">on</option>
                      <option value="false">off</option>
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
